import ShopItemsView from "../../components/shopItemsView/shopItemsView";

const RawMaterialOwnerView = () => {
    return (
        <div>
            <ShopItemsView update="/raw-item-update" urlone="/rawmaterial-owner-profile" deleteurl="/rawmaterial-owner-profile"/>
        </div>
    )
}
export default RawMaterialOwnerView;